<template>
  <div class="flex-c">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      style="margin: 0 10px 10px 0"
      @click="operationBtn()"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('receivablePayable.ImportCalculatePrices')"
    />

    <!--    版本选择-->
    <RecalculateDialog
      :visible="visible"
      :list="List"
      :quotation-list="quotationList"
      @close="cancel"
      @shutOff="shutOff"
      @confirm="RecalculateConfirm"
    />
  </div>
</template>

<script>
const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';
import { apiPayableTransportExpenseGetQuoteByOrderNo } from '@/api/finance/receivables';
import uploadExcel from '@/components/UploadExcel';
import RecalculateDialog from './Dialog/index.vue';

export default {
  name: 'ImportAddFee',
  components: {
    uploadExcel,
    RecalculateDialog
  },
  props: {
    // 重算类型
    calculationType: {
      type: Number,
      default: 2
    },
    // 业务类型
    businessType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false, // 版本弹窗
      quotationList: {}, // 报价数据
      List: [] // 导入单号数据
    };
  },
  methods: {
    // 下载模板
    operationBtn() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        if (that.calculationType === 2) {
          Sheet1.columns = [
            {
              header: '业务单号',
              key: 'waybillNumber',
              width: 40
            }
          ];
          Sheet1.getCell('A2').value = 'número do negócio';
        } else if (that.calculationType === 3) {
          Sheet1.columns = [
            {
              header: '业务单号',
              key: 'waybillNumber',
              width: 40
            },
            {
              header: '计费重量（KG）',
              key: 'weight',
              width: 40
            }
          ];
          Sheet1.getCell('A2').value = 'número do negócio';
          Sheet1.getCell('B2').value = 'Peso faturável（KG）';
          Sheet1.mergeCells('A3:B3');
        }
        Sheet1.getCell('A3').value = '每次仅导入100000条（Importar apenas 100000 itens de cada vez）';
        Sheet1.getRow(3).getCell(1).font = {
          color: { argb: 'ff0000' }
        };
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName =
          that.calculationType === 2 ? that.$t('receivablePayable.ImportRecalculatePricesTemplate') + '.xlsx'
            : that.$t('receivablePayable.ImportWeightRecalculationPriceTemplate') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },
    // 导入费用
    importLogistics(array) {
      try {
        const dataArr = [];
        const arrData = array[0].results.splice(2);
        let logisticsKey = {};
        if (this.calculationType === 2) {
          logisticsKey = {
            '业务单号': 'waybillNumber'
          };
        } else {
          logisticsKey = {
            '业务单号': 'waybillNumber',
            '计费重量（KG）': 'weight'
          };
        }
        arrData.map((item) => {
          const dataObj = {};
          for (const k in logisticsKey) {
            if (item[k]) {
              dataObj[logisticsKey[k]] = item[k];
            } else {
              dataObj[logisticsKey[k]] = '';
            }
          }
          dataArr.push(dataObj);
        });
        this.List = dataArr;
        console.log(dataArr);
        if ([4, 7].includes(this.businessType)) {
          // 获取自定义报价
          this.showRerunConfirmDialog();
        } else {
          // 默认重算
          this.$emit('importPrice', { data: dataArr });
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 关闭自定义版本弹窗
    cancel() {
      this.visible = false;
    },
    // 关闭重算弹窗
    shutOff() {
      this.$emit('close');
    },
    // 重算
    RecalculateConfirm(obj) {
      console.log(obj, '导入重算数据');
      this.cancel();
      this.$emit('importPrice', obj);
    },
    // 获取自定义重算
    showRerunConfirmDialog() {
      this.queryQuote();
    },
    // 单号查询报价
    queryQuote() {
      if (this.visible) {
        return;
      }

      this.visible = false;
      this.quotationList = {};

      const params = {
        payableType: this.businessType,
        numberField: 'waybill_number',
        numberList: this.List.map((item) => item.waybillNumber)
      };
      apiPayableTransportExpenseGetQuoteByOrderNo(params).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.visible = true;
          this.quotationList = res.data;
        }
      }).catch((err) => {
        console.log(err);
        this.visible = false;
      });
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  flex-wrap: wrap;
}
</style>
